import React from 'react';
import { Spin, Typography, Space } from 'antd';
import { LoadingOutlined, SafetyCertificateOutlined } from '@ant-design/icons';

const { Title, Text } = Typography;

export const AdminLoading: React.FC = () => {
  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        flexDirection: 'column',
      }}
    >
      <Space direction="vertical" size="large" align="center">
        <div
          style={{
            fontSize: 64,
            color: '#fff',
            marginBottom: 16,
          }}
        >
          <SafetyCertificateOutlined />
        </div>

        <Spin
          indicator={
            <LoadingOutlined style={{ fontSize: 32, color: '#fff' }} spin />
          }
          size="large"
        />

        <div style={{ textAlign: 'center' }}>
          <Title level={3} style={{ color: '#fff', marginBottom: 8 }}>
            Verifying Admin Access
          </Title>
          <Text style={{ color: 'rgba(255,255,255,0.8)', fontSize: 16 }}>
            Please wait while we verify your permissions...
          </Text>
        </div>
      </Space>
    </div>
  );
};

export default AdminLoading;
